import { createFileRoute } from "@tanstack/react-router";
import { SurveyChart } from "./-components/survey-chart";
import { SurveyGate } from "./-components/survey-gate";

export const Route = createFileRoute("/survey-portal/$residentId")({
  component: SurveyResidentPage,
});

/** One resident's chart for a surveyor, behind the same gate as the list: a bookmark cannot skip
 * it. */
function SurveyResidentPage() {
  const { residentId } = Route.useParams();
  return (
    <SurveyGate next={`/survey-portal/${residentId}`}>
      {() => <SurveyChart residentId={residentId} />}
    </SurveyGate>
  );
}
